// @ts-nocheck
import capitalize from 'lodash/capitalize'
import { Teaser as t } from '@xprog/prensa/types'
import Icon from 'components/Icon/Icon.index'
import { useIcon } from 'hooks/useIcon'

const handleUseIcon = ({ color, icon }) => {
  let iconConfig
  const sectionSlug = capitalize(color?.replace('Main', ''))
  if (sectionSlug) {
    const iconSlug = icon?.replace('Especial', sectionSlug)
    const iconParsed = useIcon(iconSlug)
    if (iconParsed.src) {
      iconConfig = iconParsed
    }
  }
  if (!iconConfig) {
    iconConfig = useIcon(icon)
  }
  return <Icon {...iconConfig} />
}

export const TeaserRelated: t.TeaserProps = {
  css: {
    p: 0,
    background: 'none !important',
    width: '100%',
    '.TeaserImageContainer': {
      display: 'none'
    },
    '.TeaserSubject': {
      display: 'none !important'
    },
    '.TeaserSubtitle': {
      display: 'none !important'
    },
    'div.TeaserTitle': {
      align: ['row', 'left', 'top'],
      pb: '$0',
      mb: '$0',
      'a': {
        pb: '$0',
        mb: '$0',
        width: '100%'
      },
      'img': {
        pt: '6px',
        height: '15px'
      },
      'p.TeaserTitleText': {
        align: ['row', 'left', 'top'],
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '19px',
        ml: '$3',
        mb: '$0',
        mt: '$0',
        textAlign: 'left',
        width: 'calc(100% - $3)'
      },
    },
    '.TeaserWrap': {
      background: 'none !important',
      pb: '$0',
      mb: '$0',
    }
  },
  className: 'TeaserRelated',
  relatedIcon: {
    enabled: true,
    name: 'IcSetaEspecial',
    useIcon: handleUseIcon
  }
}
